import template from './index.pug'

function recursivelyRemoveFill(el) {
  if (!el) {
    return
  }
  el.removeAttribute('fill');
  [].forEach.call(el.children, child => {
    recursivelyRemoveFill(child)
  })
}

export default {
  name: 'generic-svg-icon',
  template: template(),
  data() {
    return {
      svgContent: ''
    }
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    hasFill: {
      type: Boolean,
      default: false
    },
    growByHeight: {
      type: Boolean,
      default: true
    },
    classes: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: 'standard',
      required: false
    },
    color: {
      type: String,
      default: null
    },
    stroke: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    resolvedColor() {
      return getComputedStyle(document.documentElement)
        .getPropertyValue(`--${this.color}`)
        .trim()
    },
    extraClasses() {
      if (this.classes.includes('.')) return this.classes.split('.')

      return this.classes.split(' ')
    },
    size() {
      switch (this.iconSize) {
        case 'xs':
          return '18px'
        case 'sm':
          return '20px'
        case 'lg':
          return '28px'
        case 'xl':
          return '32px'
        default:
          return '24px'
      }
    }
  },
  methods: {
    async getContents() {
      const icon = this.icon.substring(this.icon.length - 4).toLowerCase() === '.svg' ?
        this.icon.substring(0, this.icon.length - 4) : this.icon
      const svgPath = require(`../../../../assets/images/${icon}.svg`)
      const response = await fetch(svgPath)
      if (!response.ok) {
        throw new Error(`Failed to fetch SVG: ${response.statusText}`)
      }
      this.svgContent = await response.text()
    },
    handleClick() {
      this.$emit('clicked')
    }
  },
  watch: {
    icon: {
      immediate: true,
      handler() {
        this.getContents().then(() => {
          if (this.$el.firstElementChild && this.$el.firstElementChild.nodeName === 'svg') {
            const svgElement = this.$el.firstElementChild
            const $svgElement = $(svgElement)

            $svgElement
              .height(this.size)
              .width(this.size)
            // use `viewBox` attribute to get the svg's inherent width and height
            const viewBox = svgElement.getAttribute('viewBox').split(' ').map(n => Number(n))
            const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2)

            if (this.hasFill) {
              // recursively remove all fill attribute of element and its nested children
              recursivelyRemoveFill(svgElement)
            }
            if (this.color) {
              const col = this.resolvedColor || this.color
              svgElement.setAttribute('fill', col)
              if (this.stroke) {
                svgElement.setAttribute('stroke', col)
              }
            }
            // set width and height relative to font size
            // if growByHeight is true, height set to 1em else
            // width set to 1em and remaining is calculated based on widthToHeight ratio
            if (this.growByHeight) {
              svgElement.setAttribute('height', '1em')
              svgElement.setAttribute('width', `${widthToHeight}em`)
            } else {
              svgElement.setAttribute('width', '1em')
              svgElement.setAttribute('height', `${1 / widthToHeight}em`)
            }

            svgElement.classList.add('svg-class')
          }
        })
      }
    }
  }
}
